export const TelLink = (props) => (
  <a
    {...props}
    href={`tel:+256${props?.phone}`}
    style={{ whiteSpace: "nowrap" }}
  >
    +256-{props?.phone}
  </a>
);

export const ExpandText = ({ children, hidden }) => {
  return (
    <p className="expandText">
      {children} <span className="hiddenText"> {hidden}</span>
    </p>
  );
};
